import styles from './style.postcss';

import is from 'is_js';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import classnames from 'classnames';
import { ContentEditable, testClass, selectElementContents } from 'omni-common-ui';

const BASE_NUM_REGEX = /^[0-9]$/;
const DECIMAL_NUM_REGEX = /^[0-9.]$/;

class EditableScoreCell extends PureComponent {
  constructor() {
    super();
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onTouchOrClick = this._onTouchOrClick.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._selectTheWholeText = this._selectTheWholeText.bind(this);
  }

  _onMouseDown(ev) {
    if (! this.props.isEditableScore) return;
    ev.preventDefault();
  }

  _onTouchOrClick(ev) {
    ev.preventDefault();
    if (! this.props.isEditableScore) return;
    const { htmlEl } = this.contentEditableComp;
    htmlEl && htmlEl.focus();
  }

  _onFocus() {
    this._selectTheWholeText();
  }

  _onKeyDown(ev) {
    const { score, fullMark, allowDecimal } = this.props;
    invariant(is.number(fullMark), 'fullMark must be numeric');
    invariant(is.string(ev.key), 'ev.key must be a string');
    if (ev.key.startsWith('Arrow')) {
      ev.preventDefault();
      ev.stopPropagation();
      return;
    }
    if (ev.ctrlKey || ev.metaKey || ev.key.length !== 1) return true;

    const keyRegex = allowDecimal ? DECIMAL_NUM_REGEX : BASE_NUM_REGEX;
    if (! keyRegex.test(ev.key)) {
      ev.preventDefault();
      return;
    }

    let currentValue = '';
    if (this.contentEditableComp && this.contentEditableComp.htmlEl) {
      currentValue = this.contentEditableComp.htmlEl.textContent || '';
    } else {
      currentValue = (is.number(score) || is.string(score)) ? score.toString() : '';
    }

    const selection = window.getSelection().toString();
    let newScore;
    if (selection) {
      newScore = currentValue.replace(selection, ev.key);
    } else {
      newScore = `${currentValue}${ev.key}`;
    }

    const [integerPart, decimalPart = ''] = newScore.split('.');

    if (allowDecimal) {
      if (ev.key === '.' && (newScore.split('.').length - 1) > 1) {
        ev.preventDefault();
        return;
      }

      if (integerPart === '' && ev.key === '.') {
        return;
      }

      if (decimalPart.length > 2) {
        ev.preventDefault();
        return;
      }
    }

    if (integerPart.length > 2 || (integerPart.startsWith('0') && integerPart.length > 1)) {
      ev.preventDefault();
      return;
    }

    const numericValue = Number.parseFloat(newScore);
    console.log(numericValue);
    if (! isNaN(numericValue) && numericValue > fullMark) {
      ev.preventDefault();
    }
  }

  _selectTheWholeText() {
    selectElementContents(this.contentEditableComp.htmlEl);
  }

  render() {
    const {
      className,
      score,
      previousScore,
      isEditableScore,
      fullMark,
      onChange,
    } = this.props;

    const { showAsPercentage } = this.props;
    const displayAsPercentage = showAsPercentage && ! isEditableScore;
    const isPreviousScoreShown = ! isEditableScore &&
        is.number(previousScore) && previousScore !== score;
    const previousScorePart = isPreviousScoreShown ?
      <div className={styles.EditableScoreCell_previousScore}>
        <span className={testClass('previous-score')}>
          {displayAsPercentage
            ? `${Math.round(previousScore * 100 / fullMark)}%`
            : previousScore}
        </span>
        {! displayAsPercentage && `/${fullMark}`}
      </div> : null;
    let scoreStyle = {};
    if (score / fullMark < 0.6 && ! isEditableScore) {
      scoreStyle = styles.EditableScoreCell_low;
    } else {
      scoreStyle = styles.EditableScoreCell;
    }

    return <div className={classnames(scoreStyle, className, {
      [styles.__editable]: isEditableScore,
    })}
        ref={(ref) => { this.outerNode = ref; }}
        onMouseDown={this._onMouseDown}
        onClick={this._onTouchOrClick}
        onTouchStart={this._onTouchOrClick}>
      <div className={styles.EditableScoreCell_currentScore}>
        <ContentEditable className={classnames(
                styles.EditableScoreCell_currentScore_editor,
                testClass('score-editor'))}
            ref={(ref) => { this.contentEditableComp = ref; }}
            html={displayAsPercentage && is.number(score)
              ? `${Math.round(score * 100 / fullMark)}%`
              : (is.number(score) ? score.toString() : '')}
            disabled={! isEditableScore}
            onFocus={this._onFocus}
            onChange={onChange}
            onKeyDown={this._onKeyDown}
            onMouseDown={this._onMouseDown}
            onClick={this._selectTheWholeText}
            onTouchStart={this._selectTheWholeText} />
        {! displayAsPercentage && <span className={styles.EditableScoreCell_currentScoreFullMark}>
            /{fullMark}
        </span>}
      </div>
      {previousScorePart}
    </div>;
  }
  }

EditableScoreCell.propTypes = {
  className: PropTypes.string,
  score: PropTypes.number,
  previousScore: PropTypes.number,
  fullMark: PropTypes.number.isRequired,
  isEditableScore: PropTypes.bool,
  onChange: PropTypes.func,
  allowDecimal: PropTypes.bool,
  showAsPercentage: PropTypes.bool,
};

EditableScoreCell.defaultProps = {
  className: '',
  score: 0,
  previousScore: null,
  isEditableScore: false,
  onChange: () => {},
  allowDecimal: false,
  showAsPercentage: false,
};

export default EditableScoreCell;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/CourseView/EditableScoreCell/index.jsx